import { IonButton, IonMenu } from '@ionic/react';
import styled from 'styled-components';

export const StyledMobileMenu = styled(IonMenu as any)`
  --ion-background-color: var(--allie-color-menu);
  width: 100%;
  z-index: 20001 !important;

  &::part(container) {
    width: 100%;
    background-color: var(--allie-color-menu);
    justify-content: flex-start;
    z-index: 20001 !important;
    pointer-events: auto !important;
  }

  &::part(backdrop) {
    z-index: 20000 !important;
    pointer-events: auto !important;
  }

  /* Asegurar que todos los elementos interactivos funcionen */
  ion-item,
  ion-list,
  .scrollbar,
  .menu-link-group,
  ion-label,
  ion-icon {
    pointer-events: auto !important;
    z-index: inherit;
  }

  .menu-link-group {
    color: white; /* Cambiar de red a white */
    cursor: pointer;
    &::before {
      display: none;
    }
    &::after {
      display: none;
    }
  }

  .icon-button {
    display: block;
  }

  .item-level-2 {
    position: relative;
    padding-left: 30px;

    //left border
    &::before {
      content: '';
      position: absolute;
      left: 25px;
      top: 0;
      bottom: 0;
      width: 1px; // Width of the border line
      border-left: 1px dotted var(--allie-color-menu-arrow);
    }

    // arrow pointing right
    &::after {
      content: '';
      position: absolute;
      left: 25px;
      top: 50%;
      width: 15px; // Length of the arrow
      height: 1px; // Thickness of the arrow
      background-color: var(--allie-color-menu-arrow);
      clip-path: polygon(0 0, 100% 50%, 0 100%);
    }

    ion-icon {
      width: 0;
    }
  }

  ion-item {
    cursor: pointer !important;
    pointer-events: auto !important;

    &::part(native) {
      padding: 0 12px;
      pointer-events: auto !important;
    }

    .menu-link-group {
      color: white;
      display: block;
      padding-left: 8px;
      pointer-events: auto !important;
    }

    ion-icon {
      &:last-child {
        width: 12px;
        height: 12px;
        display: block;
      }
    }
  }

  .logo {
    width: 185px;

    div {
      display: block;
    }
  }

  .logo-img {
    height: 32px;
  }

  .non-icon-style {
    position: relative;
    padding-left: 25px;

    #empty-icon-menu {
      display: none;
    }

    // Create the left border
    &::before {
      content: '';
      position: absolute;
      left: 25px;
      top: 0;
      bottom: 0;
      width: 1px; // Width of the border line
      background-color: var(--allie-color-menu-arrow); // Color of the border line
    }

    // Create the arrow pointing right
    &::after {
      content: '';
      position: absolute;
      left: 25px;
      top: 50%;
      width: 15px; // Length of the arrow
      height: 1px; // Thickness of the arrow
      background-color: var(--allie-color-menu-arrow); // Color of the arrow
      clip-path: polygon(0 0, 100% 50%, 0 100%); // Shape the arrow
    }
  }

  .menu-header {
    padding: 0 12px;

    &::before {
      content: '';
      position: absolute;
      bottom: -16px;
      left: 5%;
      width: 90%;
      height: 1px;
      background-color: var(--allie-color-menu-arrow);
    }
  }

  .item-level-0,
  .accordion-level-0 {
    border-top: 1px solid var(--allie-color-neutral-70);

    &::before {
      display: none;
    }

    &::after {
      display: none;
    }
  }

  .selected {
    background: #1f242f;
    --background: #1f242f;
    border-radius: 8px;
    font-weight: 800;
  }

  ion-label {
    margin-top: 0;
    margin-bottom: 0;
    padding-top: 8px;
    padding-bottom: 8px;
  }

  .menu-margin {
    padding: 4px 8px;
  }

  ion-icon {
    color: white;
    margin-inline-end: 0;
    width: 16px;
    height: 16px;
    margin-inline-start: 0;
    color: var(--ion-color-primary-contrast);
    --color: var(--ion-color-primary-contrast);
  }

  .icon-button {
    display: block;
  }

  .menu-header {
    padding: 0 12px;

    &::before {
      bottom: -16px;
      left: 5%;
      width: 90%;
    }
  }

  .menu-link-group {
    &::before,
    &::after {
      display: none;
    }
  }

  .logo {
    width: 185px;

    div {
      display: block;
    }
  }

  .logo-img {
    height: 32px;
  }

  .selected {
    background: #1f242f;
    --background: #1f242f;
    border-radius: 8px;
    font-weight: 800;
  }

  .menu-margin {
    padding: 4px 8px;
  }

  .scrollbar {
    overflow-y: scroll;
  }

  .item-level-0,
  .accordion-level-0 {
    .menu-link-group {
      font-weight: 600;
    }

    .selected {
      background: #1f242f;
      --background: #1f242f;
      border-radius: 8px;
      font-weight: 800;
    }
  }
`;

export const MobileTabButton = styled(IonButton as any)`
  flex: 1;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;

  // Usar CSS custom properties de Ionic
  --width: 100%;
  --height: 100%;
  --padding-start: 0;
  --padding-end: 0;

  // Asegurar que el contenido interno también tome el 100%
  &::part(native) {
    height: 100%;
  }
`;
